export default "__VITE_ASSET__62b8f013__"